import React from 'react';
import {
    Dialog,
    DialogActions,
    Typography,
    Button,
    Box,
    MenuItem,
    Select as MuiSelect,
    styled
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import checkIcon from '../../../assests/images/check-icon.png';
import cashIcon from '../../../assests/images/cash-icon.png';
import creditCardIcon from '../../../assests/images/credit-card-icon.png';
import bankIcon from '../../../assests/images/bank-icon.png';

const StyledDialogTitle = styled('div')({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#025366',
    padding: '20px'
});

const StyledDialogContent = styled('div')({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

const FileAssignmentDialog = ({
    open,
    onClose,
    documents,
    filePaymentMethodMap,
    setFilePaymentMethodMap,
    onContinue,
    isReceiptUpload = false // Hide "receipt" option for receipt/invoice receipt uploads
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <StyledDialogTitle>{t('AssignPaymentMethodsToFiles')}</StyledDialogTitle>
            <StyledDialogContent>
                <Typography variant="body2" color="#666" sx={{ mb: 3 }}>
                    {t('SelectPaymentMethodForEachFile')}
                </Typography>
                <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {documents.map((file, index) => (
                        <Box
                            key={index}
                            sx={{
                                mb: 2,
                                p: 2,
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                backgroundColor: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <Typography sx={{ flex: 1, fontWeight: 500 }}>
                                {index + 1}. {file.name}
                            </Typography>
                            <MuiSelect
                                value={filePaymentMethodMap[index] || 'checks'}
                                onChange={(e) => {
                                    const newMap = [...filePaymentMethodMap];
                                    newMap[index] = e.target.value;
                                    setFilePaymentMethodMap(newMap);
                                }}
                                sx={{ minWidth: 200 }}
                                size="small"
                            >
                                <MenuItem value="checks">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <img src={checkIcon} alt="check" style={{ width: 20, height: 20 }} />
                                        {t('Checks')}
                                    </Box>
                                </MenuItem>
                                <MenuItem value="cash">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <img src={cashIcon} alt="cash" style={{ width: 20, height: 20 }} />
                                        {t('Cash')}
                                    </Box>
                                </MenuItem>
                                <MenuItem value="creditcards">
                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                                        <img src={creditCardIcon} alt="credit card" style={{ width: 20, height: 20 }} />
                                        {t('CreditCards')}
                                    </Box>
                                </MenuItem>
                                <MenuItem value="banktransactions">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <img src={bankIcon} alt="bank" style={{ width: 20, height: 20 }} />
                                        {t('BankTransactions')}
                                    </Box>
                                </MenuItem>
                                {/* Hide "receipt" option for receipt/invoice receipt uploads */}
                                {!isReceiptUpload && (
                                    <MenuItem value="receipt">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            📄 {t('Receipt')}
                                        </Box>
                                    </MenuItem>
                                )}
                            </MuiSelect>
                        </Box>
                    ))}
                </Box>
            </StyledDialogContent>
            <StyledDialogActions>
                <Button
                    onClick={onClose}
                    sx={{ color: '#666' }}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    variant="contained"
                    onClick={onContinue}
                    sx={{
                        backgroundColor: '#304FFF',
                        '&:hover': { backgroundColor: '#1E40FF' }
                    }}
                >
                    {t('Continue')}
                </Button>
            </StyledDialogActions>
        </Dialog>
    );
};

export default FileAssignmentDialog;

